import { clientbookApi } from '../core/clientbook-api';

/**
 * Preview audience for a given configuration.
 * Returns { total } by default, or { total, clients[] } when include='clients'.
 *
 * @param {Object} options
 * @param {Object} options.configuration - CustomerFilter JSON configuration
 * @param {Object} [options.params] - Query params: include, limit, offset, search, sort
 * @param {boolean} [options.loadingStatusOff] - Disable loading indicator
 */
export const previewAudience = async ({ configuration, query = {}, loadingStatusOff = false }) => {
  return clientbookApi.post({
    url: '/merchants/audiences/preview',
    data: { configuration },
    query,
    loading: !loadingStatusOff,
  });
};
